<template>
  <v-card class="elevation-0">
        <v-card-title class="grey--text">
              <div class="display-1 ">{{item.name}}</div>
        </v-card-title>
        <v-list>
          <v-list-item>
            <v-list-item-action>
              <v-icon color="primary">location_on</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{item.address}}</v-list-item-title>
              <v-list-item-subtitle>{{item.zip}} {{item.city}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
</template>
<script>
import Auth from '@/core/auth';
export default {
  props: ['id'],
  data () {
    return {
      item: {}
    }
  },
  computed: {
    driver: Auth.getUser
  },
  methods: {
    getdata () {
      var app = this;
      var id = this.id;
      console.log('update destination detail');
      this.$http
      .get('api/destination/' + id)
      .then(response => {
        console.log('response destination data:', response.data);
        app.item = response.data[0];
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    }
  },
  watch: {
    id () {
      console.log('updated destination id:', this.id)
      this.getdata();
    }
  },
  created () {
    this.getdata();
  }
}
</script>
